import { render, staticRenderFns } from "./Bookmarks.vue?vue&type=template&id=1134b199&scoped=true&"
import script from "./Bookmarks.vue?vue&type=script&lang=js&"
export * from "./Bookmarks.vue?vue&type=script&lang=js&"
import style0 from "./Bookmarks.vue?vue&type=style&index=0&id=1134b199&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1134b199",
  null
  
)

export default component.exports